// ExamStatus
export const NOT_READY = 0
export const READY = 1
export const IN_EXAM = 2
export const RETAKE = 3
// Member Level Status
export const NOT_STARTED = 0
export const PLAYING = 1
export const COMPLETED = 2

export const constants = {
  data () {
    return {
      NOT_READY,
      READY,
      IN_EXAM,
      RETAKE,
      NOT_STARTED,
      PLAYING,
      COMPLETED
    }
  }
}

export const DEVICE_WIDTH = {
  I_PHONE_5: 320,
  I_PHONE_X: 375,
  I_PAD: 768
}

export const SINGLE_LINE_MAX_TITLE_LEN = 80



// WEBPACK FOOTER //
// ./src/mixins/constants.js